import SectionTitleComponent from '@cohort/components-xps/components/SectionTitle';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {forwardRef} from 'react';

type SectionTitleProps = {
  content: string;
  titleButton?: JSX.Element;
};

const SectionTitle = forwardRef<HTMLDivElement, SectionTitleProps>((props, ref) => {
  const {content, titleButton} = props;
  const {hasDarkBg, backgroundColor} = useThemeContext();

  return (
    <SectionTitleComponent
      ref={ref}
      titleButton={titleButton}
      hasDarkBg={hasDarkBg}
      backgroundColor={backgroundColor}
      content={content}
    />
  );
});

export default SectionTitle;
